<template>
    <div class="alert_container main-block">
        <div class="alert_wrapper">
            <div v-for="message in messages" :key="message.id" class="alert_block alert_block-forwards">
                <div class="alert_content">
                    <figure>
                        <svg v-if="message.type === 'error'" width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4.47853 29.75L20.5 2L36.5215 29.75H4.47853Z" stroke="#FFB400" stroke-width="2"/>
                            <line x1="20.584" y1="11" x2="20.584" y2="21" stroke="#FFB400" stroke-width="2"/>
                            <line x1="20.584" y1="23.5" x2="20.584" y2="26" stroke="#FFB400" stroke-width="2"/>
                        </svg>
                        <svg v-else width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8.18213 14.8535L13.5641 20.0202L22.1752 11.4091" stroke="#4CAE01" stroke-width="2"/>
                            <circle cx="15.5" cy="15.5" r="14.5" stroke="#4CAE01" stroke-width="2"/>
                        </svg>
                    </figure>
                    <span v-html="message.message"></span>
                </div>
                <a href="#" class="alert_close" @click.prevent="close(message.id)">
                    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 0H35C37.7614 0 40 2.23858 40 5V40H0V0Z" fill="white"/>
                        <path d="M28 12L12 28" stroke="black" stroke-width="2"/>
                        <path d="M12 12L28 28" stroke="black" stroke-width="2"/>
                    </svg>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "AlertComponent",

    data: function () {
        return {
            messages: []
,        };
    },

    mounted() {
        Livewire.on('alert', this.show);

        // this.$eventBus.$on('alert', this.show);
    },

    methods: {
        show(type, text, hide = true, time = 5) {
            console.log('test');
            let id = this.makeid();

            this.messages.push({
                id: id,
                message: text,
                type: type,
                hidden: false,
                time: time,
            });

            if(hide) {
                setTimeout(() => {
                    this.close(id);
                }, time * 1000);
            }
        },

        close(id) {
            this.messages = this.messages.filter((item) => {
                return item.id !== id;
            });
        },

        makeid(length = 16) {
            let result           = '';
            let characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            let charactersLength = characters.length;

            for ( let i = 0; i < length; i++ ) {
                result += characters.charAt(Math.floor(Math.random() *
                    charactersLength));
            }

            return result;
        }
    },
}
</script>

<style scoped>

</style>
